import { Platform } from 'react-native';
import { API_HOST } from '@/constants/config';
import { trackUser, trackWhopCompleteRegistration } from '@/constants/utils/analytics';
import { trackAuthEvent, AUTH_ACTION } from '@/constants/utils/analyticsEvents';
import { consumeCheckoutSignInReturn } from '@/lib/checkoutSignInReturn';

const isWeb = Platform.OS === 'web';

export async function handleSSOResponse(data, setAuthData, onSuccess, provider) {
  const { router } = require('expo-router');

  if (data.mfaRequired && data.ticket) {
    router.push({ pathname: '/login-authorize', params: { ticket: data.ticket } });
    return;
  }

  if (data.tokens?.access) {
    await setAuthData(data.tokens.access, data.tokens.expiresAt, data.tokens.refresh, data.user);
  }

  if (data.user?.id) trackUser(data.user.id);
  trackAuthEvent(
    data.isNewUser ? AUTH_ACTION.SIGNUP_SUCCESS : AUTH_ACTION.LOGIN_SUCCESS,
    provider || 'sso',
  );
  if (data.isNewUser) {
    trackWhopCompleteRegistration();
  }
  onSuccess?.(data);
  router.replace(isWeb ? consumeCheckoutSignInReturn() || '/' : '/(app)/app');
}

export async function postSSOLogin(endpoint, body) {
  const response = await fetch(`${API_HOST}${endpoint}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  const data = await response.json();

  if (!response.ok || data.error) {
    throw new Error(data.message || 'Authentication failed. Please try again.');
  }

  return data;
}
